module.exports = __webpack_public_path__ + "static/js/refresh.56330359.chunk.worker.js"